import { render, staticRenderFns } from "./MaterialPreviewerTable.vue?vue&type=template&id=8ec848b6&scoped=true&"
import script from "./MaterialPreviewerTable.vue?vue&type=script&lang=js&"
export * from "./MaterialPreviewerTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPreviewerTable.vue?vue&type=style&index=0&id=8ec848b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec848b6",
  null
  
)

export default component.exports